import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    TextField,
    Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SchoolIcon from "@mui/icons-material/School";
import { useState } from "react";
import { getAcademicYear } from "../utils/academicYear";
import { ArrowBack, Delete } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import AuthService from "../Auth/AuthService";
import CheckMarksheetReceipt from "../reciept/CheckMarksheetReceipt"

export default function CheckResultPage() {

    const [search, setSearch] = useState({
        searchBy: "rollNo",
        keyword: "",
        academicYear: getAcademicYear(),
        exam: "Annual",
    });
    const [student, setStudent] = useState([])
    const DOC_URL = AuthService.DOC_URL
    const navigate = useNavigate();

    const handleChange = (e) => {
        setSearch({
            ...search,
            [e.target.name]: e.target.value,
        });
    };

    const handleSearch = () => {
        console.log(search);
        const url = AuthService.pathUrl('POST', '/marksheets/check-result');
        const result = AuthService.restPost(url, search);
        console.log(result);
        const updatedResult = {
          ...result,
          logo: DOC_URL + result.logo
        };
        setStudent(updatedResult)
    };

    return (
        <Box
            sx={{
                maxWidth: 1000,
                mx: "auto",
                // mt: 5,
                // px: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >

            <Card elevation={0}>
                <IconButton color="error" onClick={() => navigate(-1)} >
                    <ArrowBack />
                </IconButton>
                <CardContent>

                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        mb={3}
                    >
                        <SchoolIcon
                            sx={{
                                fontSize: 45,
                                color: "#1b1914",
                                mr: 1,
                            }}
                        />

                        <Typography
                            variant="h5"
                            fontWeight="bold"
                        >
                            Check Result Online
                        </Typography>
                    </Box>

                    <Grid container spacing={2}>

                        <Grid item xs={12} md={6}>
                            <TextField
                                select
                                fullWidth
                                label="Search By"
                                name="searchBy"
                                value={search.searchBy}
                                onChange={handleChange}
                            >
                                <MenuItem value="rollNo">
                                    Roll Number
                                </MenuItem>

                                <MenuItem value="studentId">
                                    Student ID No.
                                </MenuItem>

                                {/* <MenuItem value="registrationNo">
                                    Registration Number
                                </MenuItem> */}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Enter Number"
                                name="keyword"
                                value={search.keyword}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                select
                                fullWidth
                                label="Academic Year"
                                name="academicYear"
                                value={search.academicYear}
                                onChange={handleChange}
                            >
                                <MenuItem value={search.academicYear}>
                                    {search.academicYear}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                select
                                fullWidth
                                label="Exam"
                                name="exam"
                                value={search.exam}
                                onChange={handleChange}
                            >
                                <MenuItem value="Unit Test">
                                    Unit Test
                                </MenuItem>

                                <MenuItem value="Half Yearly">
                                    Half Yearly
                                </MenuItem>

                                <MenuItem value="Annual">
                                    Annual Exam
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={<SearchIcon />}
                                sx={{
                                    height: 50,
                                    bgcolor: "#1b1914",
                                    fontWeight: "bold",
                                }}
                                onClick={handleSearch}
                            >
                                Check Result
                            </Button>
                        </Grid>

                    </Grid>
                </CardContent>
                <CheckMarksheetReceipt receiptData={student} />
            </Card>
        </Box>
    );
}